import { useUiStore } from '../../hooks/ui.store'
import type { Translation } from '../i18n.types'
import { getMessages } from '../messages'

/** Admin UI language and dictionary; components re-render on a language switch. */
export function useT(): Translation {
  const locale = useUiStore((s) => s.uiLocale)

  return { locale, t: getMessages(locale) }
}
